// removed by extract-text-webpack-plugin
module.exports = {"container":"notFound__container___3Vmr2","fadein":"notFound__fadein___Zulrn","gif":"notFound__gif___1OrPv","message":"notFound__message___2vZz5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/notFound/notFound.scss
// module id = 400
// module chunks = 0